/**
 * Kontrolka odpowiedzialna za rysowanie wykresów słupkowych.
 * Dane w konfiguracji:
 *  container-id - id kontenera
 *  data - dane dla wykresu
 *  name-mapping - mapowanie danych w wykresie
 *  colors - kolory dla konkretnych partii danych
 * Funkcje:
 *  init()
 *  prepareData() - przygotowanie danych w formie określonej przez plugin chart.js
 *  drawChart() - rysowanie wykresu za pomocą pluginu chart.js
 */
"use strict";

Chart.types.Line.extend({
    name: "LineAlt",
    draw: function () {
        if (typeof this.scale !== 'undefined') {
            this.scale.xScalePaddingLeft = 60; //przestrzeń dla lewej labelki
        }
        //this.scale.xScalePaddingRight = 130;
        Chart.types.Line.prototype.draw.apply(this, arguments);

        const ctx = this.chart.ctx;
        ctx.save();
        // text alignment and color
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";
        ctx.fillStyle = this.options.scaleFontColor;
        // position

        const x = this.scale.xScalePaddingLeft * 0.4 - 5;
        const y = this.chart.height / 2;
        // change origin
        ctx.translate(x, y);
        // rotate text

        ctx.rotate(-90 * Math.PI / 180);
        ctx.fillText(this.options.labelY, 0, 0);
        ctx.restore();
    }
});


(function (global) {
    class DdosProtocolChart {
        constructor(config) {
            this.settings = {
                colors: {
                    "1": "#ff6600",
                    "2": "#4bb4e6",
                    "3": "#fadc00",
                    "4": "#50be87",
                    "5": "#9164cd",
                    "6": "#ffb4e6",
                    "7": "#d54733"
                }
            };

            this.options = null;
            this.myBarChart = null;
            this.init(config);
        }

        init(config) {
            const settings = this.settings;
            let data;
            if (config["multidata"] === true) {
                data = this.prepareData(config, settings);
            } else {
                data = this.prepareSingleData(config, settings);
            }

            this.drawChart(config, data);

        }

        objectSize(object) {
            const keys = Object.keys(object);

            return keys.length;
        }

        colorLuminance(hex, lum) {
            hex = String(hex).replace(/[^0-9a-f]/gi, "");
            if (hex.length < 6) {
                hex = hex.replace(/(.)/g, '$1$1');
            }
            lum = lum || 0;
            let rgb = "#",
                c;
            for (let i = 0; i < 3; ++i) {
                c = parseInt(hex.substr(i * 2, 2), 16);
                c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
                rgb += ("00" + c).substr(c.length);
            }
            return rgb;
        }

        prepareData(config, settings) {
            const data = config["data"];
            const xAxis = [];
            const dataSet = {};
            let colorsCounter = 1;
            let colorHighlight;
            let colorRepeat = 0;

            const labelY = config["label_y"];
            const defaultShow = config["default_show"];

            $.each(data, (index, val) => {
                xAxis.push(val.name);
                if (val.values) {
                    $.each(val.values, function (index, val) {
                        if (typeof dataSet[index] == 'undefined') {
                            dataSet[index] = [];
                        }
                        dataSet[index].push(val);
                    });
                }
            });

            const tmpDataSet = [];
            let counter = 0;
            $.each(dataSet, (index, val) => {
                let color;
                if (typeof config["colors"] != 'undefined') {
                    let tmp = config["colors"][index];
                    color = "rgba(" + tmp + ",0.9)";
                    colorHighlight = "rgba(" + tmp + ",1)";
                } else {
                    let tmp = settings["colors"][colorsCounter];
                    if (colorsCounter >= this.objectSize(settings["colors"])) {
                        colorsCounter = 1;
                        colorRepeat++;
                    }
                    const lum = (colorRepeat / 10);
                    color = this.colorLuminance(tmp, -lum);
                    // color = "rgba(" + tmp + ",0.9)";
                    colorHighlight = this.colorLuminance(tmp, -lum - 0.05);
                    colorsCounter++;
                }
                let name = index;
                if (typeof config["name_mapping"] != 'undefined') {
                    $.each(config["name_mapping"], function (index, val) {
                        if (name === index) {
                            name = val;
                        }
                    });
                }

                let tmp = {
                    label: name,
                    fillColor: color,
                    strokeColor: color,
                    pointColor: color,
                    pointStrokeColor: color,
                    pointHighlightFill: colorHighlight,
                    pointHighlightStroke: colorHighlight,
                    data: val
                }
                tmpDataSet.push(tmp);
                counter++;
            });

            return {
                labels: xAxis,
                label_y: labelY,
                default_show: defaultShow,
                labels_store: xAxis,
                datasets: tmpDataSet,
                datastore: tmpDataSet
            };
        }

        prepareSingleData(config, settings) {
            const data = config["data"];
            const columnsData = [];
            const xAxis = [];
            // noinspection JSUnresolvedVariable
            const labelY = data.label_y;
            // noinspection JSUnresolvedVariable
            const defaultShow = data.default_show;
            const color = this.colorLuminance(settings["colors"][1], 0.1);
            const colorHighlight = settings["colors"][1];
            const name = data["name"];

            $.each(data["values"], function (index, val) {
                xAxis.push(index);
                columnsData.push(val)
            });

            return {
                labels: [],
                label_y: labelY,
                default_show: defaultShow,
                labels_store: xAxis,
                datasets: [{
                    label: name,
                    fillColor: color,
                    strokeColor: color,
                    pointColor: color,
                    pointStrokeColor: color,
                    pointHighlightFill: colorHighlight,
                    pointHighlightStroke: colorHighlight,
                    data: columnsData
                }],
                datastore: [{
                    label: name,
                    fillColor: color,
                    strokeColor: color,
                    pointColor: color,
                    pointStrokeColor: color,
                    pointHighlightFill: colorHighlight,
                    pointHighlightStroke: colorHighlight,
                    data: columnsData
                }]
            };
        }

        legendEvents(config, chart, data, options) {
            let $legend;

            if (config['show_legend']) {
                $legend = $('<ul class="char-legend"></ul>');
                const defaultShow = data['default_show'];

                // noinspection JSUnusedLocalSymbols
                $.each(data['datastore'], function (i, v) {
                    const d = data['datastore'][i];
                    const checked = ($.inArray(d.label, defaultShow) !== -1) ? ' checked ' : '';
                    $legend.append('<li><label><input type="checkbox" ' + checked + ' /><span style="background-color:' + d.strokeColor + '"></span><strong>' + d.label + '</strong></label></li>');
                });
                $('#' + config["container-id"]).parent().after($legend);
            }

            const $chk = $legend.find('input:checkbox');
            data['datasets'] = [];
            $chk.each(function () {
                const index = $chk.index($(this));
                if ($(this).is(':checked')) {
                    data['datasets'].push(data['datastore'][index]);
                    //data['labels'].push(data['labels_store'][index]);
                }
            });
            chart.destroy();

            const id = config["container-id"];
            const ctx = document.getElementById(id).getContext("2d");

            // noinspection JSUnresolvedFunction
            chart = new Chart(ctx).LineAlt(data, options);
            $chk.on('click', function () {
                data['datasets'] = [];
                $chk.each(function () {
                    const index = $chk.index($(this));
                    if ($(this).is(':checked')) {
                        data['datasets'].push(data['datastore'][index]);
                        //data['labels'].push(data['labels_store'][index]);
                    }
                });

                chart.destroy();
                const id = config["container-id"];
                //przy przełączaniu nie potrzebujemy animacji
                options.animation = false;
                const ctx = document.getElementById(id).getContext("2d");
                // noinspection JSUnresolvedFunction
                chart = new Chart(ctx).LineAlt(data, options);
            });

        }

        fixCanvasWidth(id, config, data) {
            const $canvas = $('#' + id);
            const width = $canvas.parent().width();
            const targetWidth = data['labels'].length * 35 + 40;
            if (width < targetWidth) {
                $canvas.attr('width', targetWidth)
            } else {
                $canvas.attr('width', $canvas.parent().width())
            }
            $canvas.data('width', $canvas.width());
            $canvas.data('height', $canvas.height());
        }

        fixResize(id, config, data) {
            const $canvas = $('#' + id);
            const targetWidth = data['labels'].length * 35 + 40;
            const ctx = document.getElementById(id).getContext("2d");

            $(window).resize(() => {
                if (typeof this.myBarChart !== 'undefined' && this.myBarChart !== null) {
                    if ($canvas.parent().width() < targetWidth) {
                        $canvas.width(targetWidth);
                    } else {
                        $canvas.width($canvas.parent().width());
                    }

                    this.myBarChart.destroy();
                    this.myBarChart = new Chart(ctx).Line(data, this.options);
                    $canvas.height($canvas.data('height'));
                }
            });
        }

        drawChart(config, data) {
            const options = {
                animation: false,
                scaleBeginAtZero: true,
                scaleShowGridLines: true,
                scaleGridLineColor: "rgba(0,0,0,0.05)",
                scaleGridLineWidth: 1,
                scaleShowHorizontalLines: true,
                scaleShowVerticalLines: true,
                bezierCurve: true,
                bezierCurveTension: 0.3,
                pointDot: true,
                pointDotRadius: 4,
                pointDotStrokeWidth: 1,
                pointHitDetectionRadius: 10,
                datasetStroke: true,
                datasetStrokeWidth: 2,
                datasetFill: false,
                multiTooltipTemplate: "<%= datasetLabel %> - <%= value %>",
                labelY: data.label_y,
                onAnimationComplete: function () {
                    const sourceCanvas = this.chart.ctx.canvas;
                    const copyWidth = this.scale.xScalePaddingLeft - 5;
                    // the +5 is so that the bottommost y axis label is not clipped off
                    // we could factor this in using measureText if we wanted to be generic
                    const copyHeight = this.scale.endPoint + 5;
                    const targetCtx = document.getElementById(id + 'Axis').getContext("2d");
                    targetCtx.canvas.width = copyWidth;
                    targetCtx.fillStyle = 'rgba(255,255,255,0.8)';
                    targetCtx.fillRect(0, 0, copyWidth, copyHeight)
                    targetCtx.drawImage(sourceCanvas, 0, 0, copyWidth, copyHeight, 0, 0, copyWidth, copyHeight);
                    this.chart.ctx.clearRect(0, 0, copyWidth, copyHeight); //usuwam domyślne dane
                }
            };

            this.options = options;
            const id = config["container-id"];
            const $containerSelector = $('#' + id);

            this.fixCanvasWidth(id, config, data, this.myBarChart);

            $containerSelector.wrap('<div class="chartAreaWrapper"></div>');
            $containerSelector.parent().wrap('<div class="chartWrapper"></div>');
            const height = $containerSelector.height();
            $containerSelector.parent().after('<canvas id="' + id + 'Axis" width="0" height="' + height + '"></canvas>');

            //data.datasets = data.datastore;
            const ctx = document.getElementById(id).getContext("2d");
            // noinspection JSUnresolvedFunction
            this.myBarChart = new Chart(ctx).LineAlt(data, this.options);

            this.fixResize(id, config, data, this.myBarChart);

            this.legendEvents(config, this.myBarChart, data, options);

            $containerSelector.parent().niceScroll({
                cursorcolor: '#FF6600',
                cursorborder: '0',
                cursorborderradius: '0',
                horizrailenabled: true,
                cursorwidth: 5,
                background: '#fafafa',
                autohidemode: false
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Charts = global.NS.Charts || {};
    global.NS.Charts.DdosProtocolChart = DdosProtocolChart || {};

})(window);
